import { VkVenue } from "../app/VkVenue";

export default VkVenue;